// extracted by mini-css-extract-plugin
module.exports = {"containerSubSection":"styles_containerSubSection__6tK_Y","textSubTitle":"styles_textSubTitle__h21d3","containerSubItems":"styles_containerSubItems__wv0Tn"};